import { createServerFeatureSetter } from './helpers/server'

export const setServerProtect = createServerFeatureSetter('protect')
